// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  padding: 24px 12px;
  padding-bottom: 60px;
  overflow-x: hidden;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: var(--background-default);
}
.wrapper .title {
  font-family: AppFontBold;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: -0.01em;
  text-transform: uppercase;
  color: var(--color-black);
  text-transform: capitalize;
  text-align: start;
  padding: 0px 0px 16px;
}
.wrapper ion-col .card-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-top: 0.5px solid #c0c0bf;
  border-radius: 2px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1019607843);
  height: 100%;
  padding: 8px;
}
.wrapper ion-col .card-item .default-img {
  padding: 5px;
  object-fit: contain !important;
  background-color: #fff;
}
.wrapper ion-col .card-item .image-block {
  height: 60px;
  aspect-ratio: 67/60;
  position: relative;
  margin-right: 16px;
}
.wrapper ion-col .card-item .image-block ion-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.wrapper ion-col .card-item .image-block .plus {
  position: absolute;
  top: 10px;
  right: 10px;
  height: 32px;
  width: 32px;
}
.wrapper ion-col .card-item .info-block {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex-grow: 1;
  padding-right: 5px;
}
.wrapper ion-col .card-item .info-block .name {
  font-family: AppFontSemiBold;
  font-size: 16px;
  line-height: 128%;
  letter-spacing: 0;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--color-black);
  margin: 0 0 6px;
  display: flex;
  align-items: center;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wrapper ion-col .card-item .info-block .deposit_text {
  font-size: 9px;
  font-family: AppFont, sans-serif;
  color: var(--color-black);
  margin: 0;
  margin-top: 20px;
  text-align: center;
}
.wrapper ion-col .card-item .info-block .price {
  margin: auto 0 10px;
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 110%;
  letter-spacing: 0;
  vertical-align: middle;
}
.wrapper ion-col .card-item .button {
  background: #e6e6e6;
  height: 44px;
  width: 74px;
  border: 1px solid transparent;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: -0.02em;
  text-align: center;
}

.content_block {
  height: calc(100% - 74px);
  overflow-y: auto;
  width: 100%;
}

.footer-btn {
  position: fixed;
  bottom: 20px;
  left: 0px;
  right: 0px;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 16px;
}
.footer-btn ion-button {
  width: 100%;
  --background: #fff;
}
.footer-btn ion-button.selected {
  --background: var(--ion-color-secondary) !important;
}

.measurment_text {
  font-family: AppFont, sans-serif;
  font-size: 10px;
  color: #9f9f9f;
  text-align: left;
  padding-top: 6px;
}

.checkmark {
  height: 18px;
  width: 18px;
  display: none;
}

.selected .checkmark {
  display: block;
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
}
.selected .button {
  background: var(--ion-color-tertiary) !important;
  border: 1px solid #000000 !important;
  box-shadow: 1px 1px 0px 1px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/recomendation-article-modal/recomendation-article-modal.component.scss"],"names":[],"mappings":"AAEA;EACC,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,2CAAA;AADD;AAGC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EAEA,yBAAA;EACA,0BAAA;EAEA,iBAAA;EACA,qBAAA;AAHF;AAME;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,+BAAA;EACA,kBAAA;EACA,uDAAA;EAEA,YAAA;EACA,YAAA;AALH;AAOG;EACC,YAAA;EACA,8BAAA;EACA,sBAAA;AALJ;AAQG;EACC,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AANJ;AAYI;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AAVL;AAYI;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAVL;AAcG;EACC,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AAZJ;AAaI;EACC,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;EAEA,eAAA;EACA,aAAA;EACA,mBAAA;EAEA,sBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAdL;AAsBI;EACC,cAAA;EACA,gCAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AApBL;AAsBI;EACC,mBAAA;EAEA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;AArBL;AAyBG;EACC,mBAAA;EACA,YAAA;EACA,WAAA;EACA,6BAAA;EACA,kBAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EAEA,eAAA;EACA,iBAAA;EACA,uBAAA;EAEA,kBAAA;AA1BJ;;AA+BA;EACC,yBAAA;EACA,gBAAA;EACA,WAAA;AA5BD;;AA8BA;EACC,eAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AA3BD;AA4BC;EACC,WAAA;EACA,kBAAA;AA1BF;AA4BE;EACC,mDAAA;AA1BH;;AA8BA;EACC,gCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AA3BD;;AA6BA;EACC,YAAA;EACA,WAAA;EACA,aAAA;AA1BD;;AA8BC;EACC,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AA3BF;AA8BC;EACC,gDAAA;EACA,oCAAA;EACA,sCAAA;AA5BF","sourcesContent":["@use '../../../theme/mixins' as *;\n\n.wrapper {\n\tpadding: 24px 12px;\n\tpadding-bottom: 60px;\n\toverflow-x: hidden;\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tbackground-color: var(--background-default);\n\n\t.title {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 20px;\n\t\tline-height: 100%;\n\t\tletter-spacing: -0.01em;\n\t\ttext-transform: uppercase;\n\n\t\tcolor: var(--color-black);\n\t\ttext-transform: capitalize;\n\n\t\ttext-align: start;\n\t\tpadding: 0px 0px 16px;\n\t}\n\tion-col {\n\t\t.card-item {\n\t\t\tposition: relative;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tbackground: white;\n\t\t\tborder-top: 0.5px solid #c0c0bf;\n\t\t\tborder-radius: 2px;\n\t\t\tbox-shadow: 0px 2px 8px 0px #0000001a;\n\n\t\t\theight: 100%;\n\t\t\tpadding: 8px;\n\n\t\t\t.default-img {\n\t\t\t\tpadding: 5px;\n\t\t\t\tobject-fit: contain !important;\n\t\t\t\tbackground-color: #fff;\n\t\t\t}\n\n\t\t\t.image-block {\n\t\t\t\theight: 60px;\n\t\t\t\taspect-ratio: 67 / 60;\n\t\t\t\tposition: relative;\n\t\t\t\tmargin-right: 16px;\n\n\t\t\t\t// &:has(.default_img) {\n\t\t\t\t// \tbackground-color: var(--ion-color-primary);\n\t\t\t\t// }\n\n\t\t\t\tion-img {\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tobject-fit: cover;\n\t\t\t\t}\n\t\t\t\t.plus {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 10px;\n\t\t\t\t\tright: 10px;\n\t\t\t\t\theight: 32px;\n\t\t\t\t\twidth: 32px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.info-block {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tjustify-content: flex-start;\n\t\t\t\talign-items: flex-start;\n\t\t\t\tflex-grow: 1;\n\t\t\t\tpadding-right: 5px;\n\t\t\t\t.name {\n\t\t\t\t\tfont-family: AppFontSemiBold;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\tline-height: 128%;\n\t\t\t\t\tletter-spacing: 0;\n\t\t\t\t\tvertical-align: middle;\n\t\t\t\t\ttext-transform: uppercase;\n\t\t\t\t\tcolor: var(--color-black);\n\n\t\t\t\t\tmargin: 0 0 6px;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\n\t\t\t\t\tword-break: break-word;\n\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t-webkit-line-clamp: 2;\n\t\t\t\t\t-webkit-box-orient: vertical;\n\t\t\t\t\toverflow: hidden;\n\t\t\t\t\ttext-overflow: ellipsis;\n\n\t\t\t\t\t// @include mobile {\n\t\t\t\t\t// \tfont-size: 13px;\n\t\t\t\t\t// \t// height: 32px;\n\t\t\t\t\t// \toverflow: hidden;\n\t\t\t\t\t// }\n\t\t\t\t}\n\t\t\t\t.deposit_text {\n\t\t\t\t\tfont-size: 9px;\n\t\t\t\t\tfont-family: AppFont, sans-serif;\n\t\t\t\t\tcolor: var(--color-black);\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tmargin-top: 20px;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t}\n\t\t\t\t.price {\n\t\t\t\t\tmargin: auto 0 10px;\n\n\t\t\t\t\tfont-family: AppFontMedium;\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tline-height: 110%;\n\t\t\t\t\tletter-spacing: 0;\n\t\t\t\t\tvertical-align: middle;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.button {\n\t\t\t\tbackground: #e6e6e6;\n\t\t\t\theight: 44px;\n\t\t\t\twidth: 74px;\n\t\t\t\tborder: 1px solid transparent;\n\t\t\t\tborder-radius: 4px;\n\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: center;\n\t\t\t\talign-items: center;\n\t\t\t\tflex-shrink: 0;\n\n\t\t\t\tfont-size: 13px;\n\t\t\t\tline-height: 100%;\n\t\t\t\tletter-spacing: -0.02em;\n\n\t\t\t\ttext-align: center;\n\t\t\t}\n\t\t}\n\t}\n}\n.content_block {\n\theight: calc(100% - 74px);\n\toverflow-y: auto;\n\twidth: 100%;\n}\n.footer-btn {\n\tposition: fixed;\n\tbottom: 20px;\n\tleft: 0px;\n\tright: 0px;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\tpadding: 0 16px;\n\tion-button {\n\t\twidth: 100%;\n\t\t--background: #fff;\n\n\t\t&.selected {\n\t\t\t--background: var(--ion-color-secondary) !important;\n\t\t}\n\t}\n}\n.measurment_text {\n\tfont-family: AppFont, sans-serif;\n\tfont-size: 10px;\n\tcolor: #9f9f9f;\n\ttext-align: left;\n\tpadding-top: 6px;\n}\n.checkmark {\n\theight: 18px;\n\twidth: 18px;\n\tdisplay: none;\n}\n\n.selected {\n\t.checkmark {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\ttop: 10px;\n\t\tleft: 10px;\n\t\tz-index: 10;\n\t}\n\n\t.button {\n\t\tbackground: var(--ion-color-tertiary) !important;\n\t\tborder: 1px solid #000000 !important;\n\t\tbox-shadow: 1px 1px 0px 1px !important;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
